/**
 * Created by anatoly on 03.07.2025
 */

const BubblesStackHintLogic = {
    type: "stack",
    priority: 6,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 14) {
            return;
        }

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        return { delay: 3000, interval: 0 };
    },

    findMove: function () {
        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        if (!Merge2.current || !Merge2.current.isGameMode() || Merge2.current.field.countEmptySlots() < 2) {
            return;
        }

        const bubbleStack = Merge2.current.bubblesStack;
        if (!bubbleStack || bubbleStack.isEmpty()) {
            return;
        }

        const bubbleStackView = cleverapps.aims.getTarget(BubblesStack.ID, {
            noDefault: true
        });
        if (!bubbleStackView) {
            return;
        }

        return {
            type: BubblesStackHintLogic.type,
            delay: config.delay,
            interval: config.interval,
            target: bubbleStackView
        };
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(BubblesStackHintLogic);
